import { Box, Link, Typography } from '@mui/material';
import { Icon } from '@/components/shared/icon';
import { ExternalUrls } from '@/constants';

interface SubscriptionCompletedProps {
  onNewSubscription: () => void;
}

export const SubscriptionCompleted = ({
  onNewSubscription,
}: SubscriptionCompletedProps) => {
  return (
    <Box textAlign="center">
      <Icon name="check-icon" />
      <Typography variant="h3" my={2}>
        Matrícula realizada!
      </Typography>
      <Typography component="div" mt={1}>
        Se tiver dúvidas ou precisar alterar sua matrícula, entre em contato com
        o nosso atendimento via{' '}
        <Link href={ExternalUrls.Support}>WhatsApp</Link>.
      </Typography>
      <Typography mt={1}>
        Se deseja realizar uma nova matrícula,{' '}
        <Link onClick={onNewSubscription}>clique aqui.</Link>
      </Typography>
    </Box>
  );
};
